import { render } from "./PosPurchase.vue?vue&type=template&id=b9aa5028&scoped=true&ts=true"
import script from "./PosPurchase.vue?vue&type=script&lang=ts"
export * from "./PosPurchase.vue?vue&type=script&lang=ts"

import "./PosPurchase.vue?vue&type=style&index=0&id=b9aa5028&scoped=true&lang=css"

import exportComponent from "/home/muhammadibrahim/Myserver/Pencil_v4_envato/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9aa5028"]])

export default __exports__